import { addDays, format } from 'date-fns';
import { PeriodType } from '../../types/prompt/PeriodType';

/**
 * Podpis kubełka na osi czasu. Przy `WEEKLY` to ZAKRES („2026-07-20 - 2026-07-26"), nie sam
 * poniedziałek — panel i raport muszą opisywać punkt tak samo, inaczej ten sam wykres czyta się
 * jak dwa różne. Zakres jest przycięty do dziś, bo bieżący tydzień bywa niepełny.
 */
export const prepareHeaderDate = (date: string, periodType: PeriodType): string => {
  if (periodType === 'WEEKLY') {
    let toDate = addDays(new Date(date), 6);
    const now = new Date();

    if (toDate > now) {
      toDate = now;
    }

    return `${date} - ${format(toDate, 'yyyy-MM-dd')}`;
  }

  if (periodType === 'MONTHLY') {
    return format(date, 'yyyy-MM');
  }

  return date;
};
